function toUMDElement(ref) {
  if (!ref) return void 0;
  if (ref.element instanceof HTMLElement) {
    return ref;
  }
  return void 0;
}
export {
  toUMDElement
};
//# sourceMappingURL=toUMDElement.js.map
